import { formatMessage } from "@/utils/format-message"
import { langStore } from "@/stores/lang-store"
import HeatmapChart from "./heatmap-chart"
import { reportBundle } from "../../report-const"

const HeatmapDesktop = ({ heatmaps, label, visualMax }) => {
  const { lang } = langStore()

  return (
    <div
      className={`grid grid-cols-1 
        ${heatmaps.length === 1 ? "max-w-125" : "md:grid-cols-[repeat(auto-fit,minmax(460px,1fr))]"}
        gap-8`}
    >
      {heatmaps.map(([dong, heatmap]) => {
        const { xLabels, yLabels, data } = heatmap

        return (
          <HeatmapChart
            key={dong}
            dong={dong}
            title={formatMessage(reportBundle.byDongHousehold[lang], {
              dong,
              resource: label[lang]
            })}
            height={yLabels.length * 6 + `px`}
            xLabels={xLabels}
            yLabels={yLabels}
            data={data}
            visualMax={visualMax}
          />
        )
      })}
    </div>
  )
}

export default HeatmapDesktop
